export default "__VITE_ASSET__DIAgIR_I__"